module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/guestbooks/bravenet_guestbooks_emoji_support.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/guestbooks/bravenet_guestbooks_emoji_support.png
// module id = 16+8
// module chunks = 0